import { t } from './i18n';

/**
 * The dashboard chart catalog (JCD-17) — must match the backend's
 * dashboards.ChartSources exactly (internal/dashboards/types.go). Single
 * source of truth for the "add widget" picker; order here is the order
 * charts appear in the picker.
 */
export const CHART_CATALOG_KEYS = [
  'kpis', 'exceptions', 'sales-period', 'sales-by-store',
  'top-parts', 'top-customers', 'low-stock', 'slow-movers',
] as const;

export function chartCatalogLabel(key: string): string {
  return (t.tablero.edit.charts as Record<string, string>)[key] ?? key;
}
